import type { Release } from '../releases.ts';

export default {
  version: '0.17.5',
  date: '2026-10-02',
  title: 'Phone recorder frame rate',
  summary: [
    'Record video asks the camera for exactly the chosen rate, 25 fps by default, instead of converting it',
    'Otherwise it records at the camera’s own rate, which the recorder shows',
  ],
  features: [],
  fixes: ['Record video no longer converts the frame rate (0.17.4 is undone): it asks the camera for exactly the chosen rate, 25 fps by default, and otherwise records at the rate the camera runs at, which the recorder shows'],
} satisfies Release;
